export default __webpack_public_path__ + "static/media/gw1.1430af1f.jpg";